export const categoriesAndProperties = {
  properties: "Ιδιότητες",
  addProperty: "Προσθήκη Ιδιότητας",
  addCategory: "Προσθήκη Κατηγορίας",
  addSubCategory: "Προσθήκη Υποκατηγορίας",
  addExtraCategory: "Προσθήκη Επιπλέον Κατηγορίας",
  category: "Κατηγορία",
  subCategory: "Υποκατηγορία",
  subCategories: "Υποκατηγορίες",
  extraCategory: "Επιπλέον Κατηγορία",
  extraCategories: "Επιπλέον Κατηγορίες",
  selectProperty: "Επιλογή Ιδιότητας",
  isNumerical: "Είναι Αριθμητική",
  value: "Αξία",
  uom: "Μονάδα Μέτρησης",
  selectCategory: "Επιλογή Κατηγορίας",
};
